export default {
  accountConfig: [],

  accountInfo: [],
  accountInfoCode: null,

  lastAccount: [],

  voucherNoteType: [],

  defaultVoucherDescription: [],

  financialRatio: [],
  financialRatioItem: {},

  numerator: [],
  denominator: [],

  voucherCheckCreate: [],
  voucherCheckUpdate: [],

  vouchers: [],
  vouchersTotalCount: 0,
  voucher: {},
  voucherNavigation: {},
  voucherId: null,
  lastVoucherInfo: {},
  voucherInfoDate: {},
  currentVoucherId: null,
  isDeleteVoucher: false,

  voucherAttaches: [],

  personCredits: [],

  userLimitAccounts: [],

  voucherNotes: [],

  confirmCartable: [],
  unConfirmCartable: [],

  voucherReview: [],

  emptyVoucher: [],

  archiveVoucher: [],
  debtorOrCreditorDeclarations: [],
  debtorOrCreditorDeclaration: {},
  debtorOrCreditorDeclarationId: null,
  debtorOrCreditorDeclarationCode: null,
  debtorOrCreditorDeclarationNavigation: {},
  debtorOrCreditorDeclarationCheckDelete: "",
  debtorOrCreditorDeclarationVoucher: [],

  voucherMaxCode: null,
  voucherMaxNumber: null,
  voucherMaxTempNumber: null,

  voucherVerification: [],
  generalJournalReport: [],
  generalJournalSummaryReport: {},

  accountOperationDetailReport: [],
  basedOnSaleManagerListReport: [],
  operationalLedgerAccountTurnoverReport: [],

  reportOfCreditorsAndDebtorsBasedOnSalesManagers: [],
  personOperationDetailReport: [],
  personOperationDetailSalt: null,
  trialBalance4ColumnsReport: [],
  detailTrialBalance4ColumnsReport: {},
  trialBalance6ColumnsReport: [],
  detailTrialBalance6ColumnsReport: {},
  trialBalance8ColumnsReport: [],
  detailTrialBalance8ColumnsReport: {},
  accountWithPersonReport: [],

  floatAccount1OperationDetail: [],
  floatAccount2OperationDetail: [],
  floatAccount3OperationDetail: [],
  floatAccount4OperationDetail: [],
  floatAccount5OperationDetail: [],
  floatAccountTextOperationDetail: [],

  accountWithFloatAccount1: [],
  accountWithFloatAccount2: [],
  accountWithFloatAccount3: [],
  accountWithFloatAccount4: [],
  accountWithFloatAccount5: [],
  accountWithFloatAccountText: [],
  accountWithFloatAccountGroupReport: null,

  floatAccount1WithPerson: [],
  floatAccount2WithPerson: [],
  floatAccount3WithPerson: [],
  floatAccount4WithPerson: [],
  floatAccount5WithPerson: [],
  floatAccountTextWithPerson: [],

  floatAccount1WithAccount: [],
  floatAccount2WithAccount: [],
  floatAccount3WithAccount: [],
  floatAccount4WithAccount: [],
  floatAccount5WithAccount: [],
  floatAccountTextWithAccount: [],

  statusDocumentReport: [],
  trialBalanceReport: [],

  personWithFloatAccount1: [],
  personWithFloatAccount2: [],
  personWithFloatAccount3: [],
  personWithFloatAccount4: [],
  personWithFloatAccount5: [],
  personWithFloatAccountText: [],

  personWithAccount: [],
  personCreditsReport: [],
  balanceReportPersonsList: [],
  personalAccountBalanceReport: [],
  electronicLedgerReport: [],
  electronicLedgerExportData: {},
  personFinalVoucherReport: [],
  personOfficeReport: [],
  personMultiLevelLedgerReport: [],

  accountTreeReport: [],

  floatAccount1BalanceReport: [],
  floatAccount2BalanceReport: [],
  floatAccount3BalanceReport: [],
  floatAccount4BalanceReport: [],
  floatAccount5BalanceReport: [],
  floatAccountTextBalanceReport: [],

  reviewAccounts: {},
  monthlyAccountingVoucherReport: {},
  monthlyAccountingVoucherExportData: {},

  floatAccount1Office: [],
  floatAccount2Office: [],
  floatAccount3Office: [],
  floatAccount4Office: [],
  floatAccount5Office: [],
  floatAccountTextOffice: [],

  routeData: {},

  finalizationDocument: {},
  unFinalizationDocument: {},

  profitAndLossIncomesReport: {},
  profitAndLossCostsReport: {},
  balanceSheetReport: {},

  financialRatioReport: [],

  voucherDetail: [],

  accountOfficeReport: [],

  printVoucherInfo: null,
  printLink: {},

  printAccountOperationDetailReportInfo: null,

  dashboardAccountOffice: {},
  dashboardAccountOfficeChart: [],

  floatAccount1BalanceTreeReport: [],
  floatAccount2BalanceTreeReport: [],
  floatAccount3BalanceTreeReport: [],
  floatAccount4BalanceTreeReport: [],
  floatAccount5BalanceTreeReport: [],
  floatAccountTextBalanceTreeReport: [],

  requiredDate: {},

  closeAccountStep: null,
  previewCloseTemporaryAccount: {},
  previewClosePermanentAccount: [],

  previewFinalDate: {},

  attachDetailVoucher: {},

  voucherNotesReport: [],

  accountCurrencyMonitoringProcess: null,
  accountCurrencyMonitoringReport: {},
  accountCurrencyMonitoringReportDetail: {},
  accountCurrencyTrialBalanceReport: {},
  accountCurrencyMonitoringNotProcessed: false,

  isError: false,

  cartableLog: [],

  voucherManagementCartable: [],

  voucherMerge: [],
  voucherMergeDetails: [],
  voucherMergeResult: [],
};
